// src/App.js
import React, { useState, useEffect } from 'react';
import './TSCarousel.css';
import hairImg from '../../assets/serviceImg/servises/haircut.jpeg'
import coloringImg from '../../assets/serviceImg/servises/coloring.jpeg';
import treatmentImg from '../../assets/serviceImg/servises/treatment.jpeg';
import curlsImg from '../../assets/serviceImg/servises/curls.jpeg';
import eluminationImg from '../../assets/serviceImg/servises/elumination.jpeg';
import lighteningImg from '../../assets/serviceImg/servises/lightening.jpeg';
import { HashLink } from 'react-router-hash-link';
import arrow from '../../assets/arrowbottomImg.png'


const slidesData = [
  {
    image1: hairImg,
    image2: coloringImg,
    image3: treatmentImg,
    text1: 'Стрижки',
    text2: 'Окрашивание',
    text3: 'Лечение и спа',
    price1: 'от 4000 руб',    
    price2: 'от 3300 руб',    
    price3: 'от 2000 руб',    
},
{
  image1: curlsImg,
  image2: eluminationImg,
  image3: lighteningImg,
  text1: 'Укладки',
  text2: 'Элюминирование',
  text3: 'Рассветление',
  price1: 'от 3000 руб',    
  price2: 'от 7000 руб',    
  price3: 'от 5000 руб',    
},
];
const slidesDatamb = [

{
  image: hairImg,
  text: 'Стрижки',
  price: 'от 4000 руб',    
},
{
  image: coloringImg,
  text: 'Окрашивание',
  price: 'от 3300 руб',    
},
{
  image: treatmentImg,
  text: 'Лечение и спа',
  price: 'от 2000 руб',    
},
{
  image: curlsImg,
  text: 'Укладки',
  price: 'от 3000 руб',    
},
{
  image: eluminationImg,
  text: 'Элюминирование',
  price: 'от 7000 руб',    
},
{
  image: lighteningImg,
  text: 'Рассветление',
  price: 'от 5000 руб',    
},]
const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return windowWidth;
};

const CarouselStyle = () => {
  const windowWidth = useWindowWidth();
  const [currentSlide, setCurrentSlide] = useState(0);
    const nextSlide = () => {
    setCurrentSlide(currentSlide === slidesDatamb.length - 1 ? 0 : currentSlide + 1);
  };

  const prevSlide = () => {
    setCurrentSlide(currentSlide === 0 ? slidesDatamb.length - 1 : currentSlide - 1);
  };
  return (
    <>
      {windowWidth > 768 ? (
      <div className="tscarousel">
        <div className="tsslides-container" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
          {slidesData.map((slide, index) => (
            <div key={index} className="tsslide">
                <div className="tscontent">
                    <div className='item'>
                        <img src={slide.image1} alt={`Slide ${index + 1}`}/>
                        <a>{slide.text1}</a>
                        <a>{slide.price1}</a>
                        <HashLink to={'/prices'}>
                          <button>Записаться</button>
                        </HashLink>
                    </div>
                    <div className='item'>
                        <img src={slide.image2} alt={`Slide ${index + 1}`}/>
                        <a>{slide.text2}</a>
                        <a>{slide.price2}</a>
                        <HashLink to={'/prices'}>
                          <button>Записаться</button>
                        </HashLink>
                    </div>
                    <div className='item'>
                        <img src={slide.image3} alt={`Slide ${index + 1}`}/>
                        <a>{slide.text3}</a>
                        <a>{slide.price3}</a>
                        <HashLink to={'/prices'}>
                          <button>Записаться</button>
                        </HashLink>
                    </div>
                </div>
            </div>
          ))}
        </div>
        <div className="tsnavigation">
          <div className="tsdots">
            {slidesData.map((_, index) => (
              <span
                key={index}
                className={`tsdot ${index === currentSlide ? 'active' : ''}`}
                onClick={() => setCurrentSlide(index)}
              />
            ))}
          </div>
        </div>
      </div>
            )
            //________________________________________________________________________
            :
            (
              <div className="tsmbcarousel">
              <div className="tsmbslides-container" style={{ transform: `translateX(-${currentSlide * 100}%)` }}>
                {slidesDatamb.map((slide, index) => (
                  <div key={index} className="tsmbslide">
                      <div className="tsmbcontent">
                          <div className='itemmb'>
                              <img src={slide.image} alt={`Slide ${index + 1}`}/>
                              <a>{slide.text}</a>
                              <a>{slide.price}</a>
                              <HashLink to={'/prices'}>
                                <button>Записаться</button>
                              </HashLink>
                          </div>
                      </div>
                  </div>
                ))}
              </div>
              <button className="ts-prevslide" onClick={prevSlide}><img src={arrow}/></button>
              <button className="ts-nextslide" onClick={nextSlide}><img src={arrow}/></button>

              <div className="tsnavigation">
                <div className="tsmbdots">
                  {slidesDatamb.map((_, index) => (
                    <span
                      key={index}
                      className={`tsmbdot ${index === currentSlide ? 'active' : ''}`}
                      onClick={() => setCurrentSlide(index)}
                    />
                  ))}
                </div>
              </div>
            </div>
              )}
              </>
    );
  };


export default CarouselStyle;
